


























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

// Models
import SanIDModel from '@/_models/SanIDModel'

// Components
import TablePagination from '@/components/shared/TablePagination.vue'

@Component({
  components: { TablePagination },
})
export default class SearchSanID extends Vue {
  // Props
  @Prop()
  selectedData!: any

  // data
  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  selected: any = {}
  searchQuery: string = ''
  selectedFilter: string = 'san_id'
  filedNameLUT: any = {
    san_id: 'SAN ID',
  }
  filedType: any[] = ['-', 'JCard', 'Smart JCard']

  // computed
  get sanids(): SanIDModel[] {
    const sanids = this.$store.state.sanids.all.items
    this.numofPage = Math.ceil(sanids.length / this.perPage)

    return sanids
  }

  get filteredData(): SanIDModel[] {
    const targetField: string = this.selectedFilter
    if (!this.sanids) {
      return []
    }

    return this.sanids.filter((item: any): boolean => {
      return String(item[targetField]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1
    })
  }

  get isLoading(): boolean {
    return this.$store.state.sanids.loading
  }

  // methods
  handleSelectFinished(): void {
    const selectedData = {
      san_id: this.selected.san_id || '',
      jbox_type: this.selected.jbox_type || 0,
    }

    this.$emit('selectedSanIDDone', selectedData)
  }

  handleToggleSelected(): void {
    if (this.selected._id) {
      this.selected = {}
    }
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  convertJBoxType(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedType[value]) as string
  }

  // After page created
  created() {
    this.$store.dispatch('sanids/getAll').then(() => {
      for (const item of this.filteredData) {
        if (
          typeof this.selectedData !== 'undefined' &&
          this.selectedData &&
          item.san_id === this.selectedData.san_id
        ) {
          this.selected = item
          return
        }
      }
    })
  }
}
